import type { InvoiceRole } from '../utils/invoiceLedger';

export const VD_HARNESS_PREFIX = 'VDTEST';
export const VD_HARNESS_NOTE = 'VDTEST harness — isolated scenario run. Safe to purge.';

export type VdScenarioId =
  | 'first-accept-creates-deposit'
  | 'final-increase-before-balance-is-works'
  | 'increase-after-balance-is-variation'
  | 'reject-creates-no-invoice';

export type VdScenarioStepStatus = 'pass' | 'fail' | 'skip';

export type VdScenarioStep = {
  id: string;
  label: string;
  status: VdScenarioStepStatus;
  detail?: string;
};

export type VdScenarioFixture = {
  runId: string;
  customerId: string;
  projectId: string;
  quoteId: string;
  lifecycleRef: string;
  organisationId: string;
  quotedGross: number;
  depositGross: number;
  shareLinkId?: string | null;
  shareToken?: string | null;
};

export type VdScenarioExpectation = {
  nextRole: InvoiceRole | null;
  delta: number;
  depositInvoiced: number;
  alreadyInvoiced: number;
};

export type VdScenarioDefinition = {
  id: VdScenarioId;
  title: string;
  summary: string;
};

export const VD_SCENARIOS: VdScenarioDefinition[] = [
  {
    id: 'first-accept-creates-deposit',
    title: 'Customer accepts First',
    summary: 'Mock accept on a new quote. Expect a frozen deposit invoice only.',
  },
  {
    id: 'final-increase-before-balance-is-works',
    title: 'Final rises before the balance',
    summary: 'Accept, then raise the settled total. The first leftover is still a balance, not a variation.',
  },
  {
    id: 'increase-after-balance-is-variation',
    title: 'Settled total rises after the balance',
    summary: 'Accept, issue the balance, then raise the total. The next leftover is a variation.',
  },
  {
    id: 'reject-creates-no-invoice',
    title: 'Customer rejects First',
    summary: 'Mock reject. Expect no deposit invoice.',
  },
];
